// extracted by mini-css-extract-plugin
export default {"validation-message":"validationMessage_validation-message__FLrMl"};